import { useEffect, useState } from "react";
import { Link, useLocation } from 'react-router-dom';
import { Box, styled } from "@mui/material";
import { useCustomMediaQuery } from "../common/useCustomMediaQuery";
import HistoryEduOutlinedIcon from '@mui/icons-material/HistoryEduOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import { themeColors } from "../common/colors";

// IconButtonを利用すると、基本メニューのメニューバーがかなり横に広く表示されたので、IconButtonを利用しない方向で回避。
// IconButton相当の見た目にするためアルファチャンネル 0.54 を指定。
export const VisualizedMenu = (props: any) => {
  const { targetPage, menuLabel, currentPath } = props;
  const { isDesktop, isMobile } = useCustomMediaQuery();

  const DEFAULT_COLOR = "rgba(0, 0, 0, 0.5)";

  // マウスホバー時のスタイル
  const linkHoverStyle = {
    color: themeColors[0],
  };
  // デフォルト時のスタイル
  const linkDefaultStyle = {
    backgroundColor: 'transparent',
    opacity: '1.0',
    color: DEFAULT_COLOR,
  };

  const sanitizedCurrentPath = currentPath.replace("DataRef", "");

  //現在開いている画面はlinkHoverStyleを適用する
  const linkLeaveStyle = sanitizedCurrentPath === targetPage ? linkHoverStyle : linkDefaultStyle;

  const DesktopMenu = styled(Link)(() => ({
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    padding: "5px 0",
    transition: 'color 0.3s',
    color: DEFAULT_COLOR,
    ...(sanitizedCurrentPath === targetPage ? linkHoverStyle : {})
  }));

  const MobileMenu = styled(Link)(() => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px 0',
    margin: '0 2px',
    fontSize: '.8rem',
    transition: 'color 0.3s',
    wordBreak: 'keep-all',
    ...(sanitizedCurrentPath === targetPage ? linkHoverStyle : linkDefaultStyle)
  }));

  return (
    <>
      {isDesktop && (
        <DesktopMenu
          to={targetPage}
          onMouseEnter={(event) => { Object.assign(event.currentTarget.style, linkHoverStyle); }}
          onMouseLeave={(event) => { Object.assign(event.currentTarget.style, linkLeaveStyle); }}>
          {props.children}
          <div style={{ marginLeft: "0.2em" }}>{menuLabel}</div>
        </DesktopMenu>
      )}
      {isMobile && (
        <MobileMenu
          to={targetPage}
          onMouseEnter={(event) => { Object.assign(event.currentTarget.style, linkHoverStyle); }}
          onMouseLeave={(event) => { Object.assign(event.currentTarget.style, linkLeaveStyle); }}>
          {props.children}
          <div style={{ textAlign: "center" }}>{menuLabel}</div>
        </MobileMenu>
      )}
    </>
  );
};

export const VisualizedMenus = () => {
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState(location.pathname);
  const { isDesktop, isMobile } = useCustomMediaQuery();

  const PageUrl = [
    { page: "/diplomaSupplement", label: "DS" },
    { page: "/credit", label: "PERSPECTIVE" },
    { page: "/trainingIndicator", label: "INDICATOR" },
    { page: "/gpa", label: "GPA" },
    { page: "/portfolio", label: "PORTFOLIO" },
    { page: "/ncbt", label: "N-CBT" },
    { page: "/sets", label: "SE・TS" },
    { page: "/chatbot", label: "CHATBOT" },
  ];

  const Menubar = styled(Box)(() => ({
    position: 'fixed',
    top: isDesktop ? '64px' : '56px',
    left: '0',
    width: '100%',
    backgroundColor: 'white',
    zIndex: '100',
  }));

  const BoxStyle = { display: 'flex', justifyContent: 'center', maxHeight: '53px' };

  const desktopMenuItems = [
    { page: PageUrl[0].page, label: PageUrl[0].label, icon: <HistoryEduOutlinedIcon /> },
    { page: PageUrl[1].page, label: PageUrl[1].label, icon: <SchoolOutlinedIcon /> },
    { page: PageUrl[2].page, label: PageUrl[2].label, icon: <QueryStatsOutlinedIcon /> },
    { page: PageUrl[3].page, label: PageUrl[3].label, icon: <TimelineOutlinedIcon /> },
    { page: PageUrl[4].page, label: PageUrl[4].label, icon: <BarChartOutlinedIcon /> },
    { page: PageUrl[5].page, label: PageUrl[5].label, icon: <EditNoteOutlinedIcon /> },
    { page: PageUrl[6].page, label: PageUrl[6].label, icon: <SummarizeOutlinedIcon /> },
    { page: PageUrl[7].page, label: PageUrl[7].label, icon: <SmartToyOutlinedIcon /> },
  ];

  const mobileMenuItems1 = [
    { page: PageUrl[0].page, label: PageUrl[0].label, icon: <HistoryEduOutlinedIcon /> },
    { page: PageUrl[1].page, label: PageUrl[1].label, icon: <SchoolOutlinedIcon /> },
    { page: PageUrl[2].page, label: PageUrl[2].label, icon: <QueryStatsOutlinedIcon /> },
    { page: PageUrl[3].page, label: PageUrl[3].label, icon: <TimelineOutlinedIcon /> },
  ];

  const mobileMenuItems2 = [
    { page: PageUrl[4].page, label: PageUrl[4].label, icon: <BarChartOutlinedIcon /> },
    { page: PageUrl[5].page, label: PageUrl[5].label, icon: <EditNoteOutlinedIcon /> },
    { page: PageUrl[6].page, label: PageUrl[6].label, icon: <SummarizeOutlinedIcon /> },
    { page: PageUrl[7].page, label: PageUrl[7].label, icon: <SmartToyOutlinedIcon /> },
  ];

  useEffect(() => {
    setCurrentPath(location.pathname);
  }, [location]);

  return (
    <Menubar>
      {isMobile ?
        (<>
          <Box sx={BoxStyle}>
            {mobileMenuItems1.map((item) => (
              <VisualizedMenu
                key={item.label}
                targetPage={item.page}
                menuLabel={item.label}
                currentPath={currentPath}
              >
                {item.icon}
              </VisualizedMenu>
            ))}
          </Box>
          <Box sx={BoxStyle}>
            {mobileMenuItems2.map((item) => (
              <VisualizedMenu
                key={item.label}
                targetPage={item.page}
                menuLabel={item.label}
                currentPath={currentPath}
              >
                {item.icon}
              </VisualizedMenu>
            ))}
          </Box>
        </>) :
        (<Box sx={BoxStyle}>
          {desktopMenuItems.map((item) => (
            <VisualizedMenu
              key={item.label}
              targetPage={item.page}
              menuLabel={item.label}
              currentPath={currentPath}
            >
              {item.icon}
            </VisualizedMenu>
          ))}
        </Box>)}
    </Menubar>
  );
};
